import { Typography } from '@breezeventures/ui-kit/typography';
import cn from 'classnames';

type ReviewItemProps = {
  className?: string;
  title: string;
  value?: string | string[] | number | null;
  hideIfEmpty?: boolean;
};

export const ReviewItem = ({
  title,
  value,
  hideIfEmpty,
  className,
}: ReviewItemProps) => {
  const valueParsed = Array.isArray(value) ? value.join(', ') : value;

  if (!valueParsed && hideIfEmpty) {
    return null;
  }

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <Typography.Text
        size="xs"
        color="secondary"
        className="line-clamp-1 text-ellipsis"
      >
        {title}
      </Typography.Text>

      <Typography.Text size="s" className={`line-clamp-1 text-ellipsis`}>
        {valueParsed ? valueParsed : '-'}
      </Typography.Text>
    </div>
  );
};
